import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  ControlContainer,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {LabelModule} from '@progress/kendo-angular-label';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {AutoFocusDirective} from '../../directives/auto-focus.directive';
import {Assessment} from '../../models/models.lib';
import {LoggerService} from '../../shared/logger.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'casi-assessment-hours',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  standalone: true,
  templateUrl: './assessment-hours.component.html',
  styleUrl: './assessment-hours.component.scss'
})
export class AssessmentHoursComponent   implements OnInit{
  private _assessment: Assessment| undefined;

  @Input({ required: true }) set assessment(val: Assessment) {
    this._assessment = val;
  }
  get assessment(): Assessment | undefined {
    return this._assessment;
  };

  @Input({ required: true }) assessmentForm!: FormGroup;

  private sub?: Subscription;

  constructor(
    private logger: LoggerService,
  ) {}

  //#region Form
  get f() {return this.assessmentForm?.controls;}
  getControl(name: string) {return this.assessmentForm.get(name);}


  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.updateTotalHours();
    this.sub = this.assessmentForm.valueChanges.subscribe(() => {
      this.updateTotalHours();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private updateTotalHours(): void {
    const form = this.assessmentForm;
    if (!form) return;
    const v = form.getRawValue();
    const total =
      (Number(v.client_contact_hours) || 0) +
      (Number(v.individual_supervision_hours) || 0) +
      (Number(v.group_supervision_hours) || 0) +
      (Number(v.other_activities_hours) || 0);

    form.get('total_hours')?.setValue(Number(total.toFixed(1)), { emitEvent: false });
  }


}
